<template>
    <div class="shrink-software">
        <!-- 顶部全局工具条：我发布的 / 我参与的 共用发布入口 -->
        <div class="top-bar">
            <span class="top-title">我的缩水软件</span>
            <el-button type="primary" size="small" @click="openPublishDialog">+ 发布缩水软件</el-button>
        </div>
        <el-tabs v-model="activeTab" @tab-click="onTabChange">
            <!-- Tab1：我发布的 -->
            <el-tab-pane label="我发布的" name="published">
                <div class="page-block">
                    <!-- 搜索 + 筛选 -->
                    <div class="header">
                        <el-input v-model="pub.query.keyword" size="small" placeholder="按软件名称搜索" clearable
                            style="width:200px" @keyup.enter.native="pubSearch" @clear="pubSearch"></el-input>
                        <el-select v-model="pub.query.preType" size="small" placeholder="彩种" clearable
                            style="width:130px" @change="pubSearch">
                            <el-option v-for="o in lotteryOptions" :key="o.value" :label="o.label" :value="o.value" />
                        </el-select>
                        <el-select v-model="pub.query.softwareSource" size="small" placeholder="软件来源" clearable
                            style="width:130px" @change="pubSearch">
                            <el-option v-for="o in sourceOptions" :key="o.value" :label="o.label" :value="o.value" />
                        </el-select>
                        <el-select v-model="pub.query.isFree" size="small" placeholder="价格类型" clearable
                            style="width:110px" @change="pubSearch">
                            <el-option label="免费" :value="1" />
                            <el-option label="付费" :value="0" />
                        </el-select>
                        <el-select v-model="pub.query.auditStatus" size="small" placeholder="审核状态" clearable
                            style="width:130px" @change="pubSearch">
                            <el-option label="待审核" :value="0" />
                            <el-option label="已通过" :value="1" />
                            <el-option label="已拒绝" :value="2" />
                        </el-select>
                        <el-date-picker v-model="pub.dateRange" type="daterange" size="small" range-separator="~"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            style="width:240px" @change="onPubDateChange">
                        </el-date-picker>
                        <el-button size="small" @click="pubSearch">查询</el-button>
                        <span class="refresh-btn" @click="pubSearch">刷新</span>
                    </div>

                    <el-table :data="pub.list" v-loading="pub.loading" style="width: 100%" empty-text="暂无发布的软件">
                        <el-table-column prop="softwareName" label="软件名称" min-width="180" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="所属彩种" width="120">
                            <template slot-scope="{ row }">
                                <el-tag effect="dark" :color="getLotteryColor(row.preType)" class="lottery-tag-custom"
                                    size="small">{{ getLotteryName(row.preType) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="软件来源" width="100">
                            <template slot-scope="scope">
                                <el-tag effect="dark" :color="getSourceColor(scope.row.softwareSourceIntro)"
                                    class="lottery-tag-custom" size="small">{{ scope.row.softwareSourceIntro || '-'
                                    }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="价格" width="100">
                            <template slot-scope="{ row }">
                                <span :style="row.priceRange === '免费' ? 'color:#67c23a' : ''">{{ row.priceRange || '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="无病毒承诺" width="100">
                            <template slot-scope="{ row }">
                                <el-tag :type="row.noVirus === 1 ? 'success' : 'danger'" size="small">{{ row.noVirus ===
                                    1 ? '是' : '否' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="自动更新开奖" width="110">
                            <template slot-scope="{ row }">
                                <el-tag :type="row.updateLottery === 1 ? 'success' : 'info'" size="small">{{
                                    row.updateLottery === 1 ? '是' : '否' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="审核状态" width="100">
                            <template slot-scope="{ row }">
                                <el-tag :type="auditType(row.auditStatus)" size="small">{{ auditText(row.auditStatus)
                                    }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="releaseTime" label="发布时间" width="160"> </el-table-column>
                        <el-table-column label="操作" width="180" fixed="right">
                            <template slot-scope="{ row }">
                                <div class="op-btns">
                                    <el-button type="text" size="mini" style="color:#409EFF;padding-left:0"
                                        @click="pubViewDetail(row)">查看详情</el-button>
                                    <el-button v-if="row.softPath" type="text" size="mini"
                                        style="color:#67C23A;padding-left:0"
                                        @click="downloadFile(row.softPath)">下载</el-button>
                                    <el-button v-if="Number(row.transferSaleStatus) === 1" type="text" size="mini"
                                        style="color:#E6A23C;padding-left:0"
                                        @click="pubOpenTransfer(row)">有偿转让</el-button>
                                    <span
                                        v-if="Number(row.transferSaleStatus) === 2 || Number(row.transferSaleStatus) === 3 || Number(row.transferSaleStatus) === 4"
                                        class="tf-status-text">{{ row.transferSaleStatusIntro }}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination v-if="pub.total > 0" class="pager" background layout="total, prev, pager, next"
                        :total="pub.total" :page-size="pub.query.pageSize" :current-page="pub.query.pageNum"
                        @current-change="pubHandlePage">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <!-- Tab2：我参与的 -->
            <el-tab-pane label="我参与的" name="joined">
                <div class="page-block">
                    <div class="header">
                        <el-button size="small" type="primary" @click="openPublishDialog">+ 发布缩水软件</el-button>
                        <span class="refresh-btn" @click="joinGetList">刷新</span>
                    </div>
                    <el-table :data="join.list" v-loading="join.loading" style="width: 100%" empty-text="暂无参与的需求">
                        <el-table-column label="需求标题" min-width="160" show-overflow-tooltip>
                            <template slot-scope="{ row }">{{ joinD(row).title || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="发布者" width="110">
                            <template slot-scope="{ row }">{{ joinD(row).publisherName || joinD(row).userName ||
                                joinD(row).createBy || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="我的报价(元)" width="110">
                            <template slot-scope="{ row }">{{ joinB(row).price || joinB(row).amount ||
                                joinB(row).bidAmount ? (joinB(row).price || joinB(row).amount || joinB(row).bidAmount) +
                            ' 元' : '-' }}</template>
                        </el-table-column>
                        <el-table-column label="期望工期(天)" width="110">
                            <template slot-scope="{ row }">{{ joinB(row).duration || joinB(row).periodDays ||
                                joinB(row).days || joinD(row).periodDays ? (joinB(row).duration || joinB(row).periodDays
                                    || joinB(row).days || joinD(row).periodDays) + ' 天' : '-' }}</template>
                        </el-table-column>
                        <el-table-column label="付费模式" width="100">
                            <template slot-scope="{ row }">
                                <el-tag :type="formatPayMode(joinD(row).mode) === '付费担保' ? 'warning' : 'success'"
                                    size="small">{{ formatPayMode(joinD(row).mode) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="当前状态" width="110">
                            <template slot-scope="{ row }">
                                <el-tag :type="joinStatusType(joinD(row).status)" size="small">{{
                                    formatStatus(joinD(row).status) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="投标时间" width="160">
                            <template slot-scope="{ row }">{{ joinB(row).createTime || row.createTime || '-'
                                }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="220" fixed="right">
                            <template slot-scope="{ row }">
                                <template v-if="row.selected === true && joinD(row).status == 12">
                                    <el-button type="primary" size="mini" @click="joinSignContract(row)">签约</el-button>
                                    <el-button type="danger" size="mini" @click="joinRejectContract(row)">拒签</el-button>
                                </template>
                                <template v-else-if="joinD(row).status == 2">
                                    <el-button type="primary" size="mini" @click="joinUploadContract()">上传合同</el-button>
                                </template>
                                <template v-else-if="joinD(row).status == 4">
                                    <el-button type="success" size="mini"
                                        @click="joinSubmitAccept(row)">申请验收</el-button>
                                    <el-button size="mini" @click="joinViewDetail(row)">查看进度</el-button>
                                </template>
                                <template v-else-if="joinD(row).status == 5">
                                    <el-tag type="warning" size="mini">等待发布者验收</el-tag>
                                </template>
                                <template v-else-if="joinD(row).status == 6 || joinD(row).status == 10">
                                    <el-button type="primary" size="mini" @click="joinWithdraw(row)"
                                        v-if="joinD(row).escrowStatus == 1 && !row.withdrawn">申请提现</el-button>
                                    <el-tag v-else type="info" size="mini">已完成</el-tag>
                                </template>
                                <el-button size="mini" @click="joinViewDetail(row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>

            <!-- Tab3：发布缩水软件 -->
            <!-- <el-tab-pane label="发布缩水软件" name="publish">
                <div class="page-block">
                    <div class="publish-tip">
                        <i class="el-icon-info"></i> 点击页面顶部「+ 发布缩水软件」按钮，在弹窗中填写完整信息并发布。软件需通过平台审核，免费 / 付费发布仅在价格填写上有差异。
                    </div>
                </div>
            </el-tab-pane> -->
        </el-tabs>

        <!-- ===================== 公共弹窗区 ===================== -->

        <!-- 我发布的：详情弹窗 -->
        <el-dialog title="软件发布详情" :visible.sync="pub.detailVisible" width="640px" append-to-body>
            <el-descriptions :column="1" border v-if="pub.detail">
                <el-descriptions-item label="软件名称">{{ pub.detail.softwareName }}</el-descriptions-item>
                <el-descriptions-item label="所属彩种">{{ pub.detail.preTypeIntro || getLotteryName(pub.detail.preType)
                    }}</el-descriptions-item>
                <el-descriptions-item label="软件来源">{{ pub.detail.softwareSourceIntro }}</el-descriptions-item>
                <el-descriptions-item label="价格">
                    <template v-if="pub.detail.priceRange">{{ pub.detail.priceRange }}</template>
                    <template v-else>
                        <el-tag :type="isFree(pub.detail) ? 'success' : 'warning'" size="small">{{ isFree(pub.detail) ?
                            '免费' : '收费' }}</el-tag>
                        <span v-if="!isFree(pub.detail)" style="margin-left:8px">{{ pub.detail.coin }} 元</span>
                    </template>
                </el-descriptions-item>
                <el-descriptions-item label="无病毒承诺">{{ pub.detail.noVirus === 1 ? '是' : '否' }}</el-descriptions-item>
                <el-descriptions-item label="自动更新开奖">{{ pub.detail.updateLottery === 1 ? '是' : '否'
                    }}</el-descriptions-item>
                <el-descriptions-item label="函数公式">{{ pub.detail.formula || '-' }}</el-descriptions-item>
                <el-descriptions-item label="软件基本情况介绍">{{ pub.detail.introduction || '-' }}</el-descriptions-item>
                <el-descriptions-item label="申请发布说明">{{ pub.detail.releaseNotes || '-' }}</el-descriptions-item>
                <el-descriptions-item label="软件存放路径">
                    <span v-if="pub.detail.softPath" class="file-link" :title="fileName(pub.detail.softPath)"
                        @click="downloadFile(pub.detail.softPath)">{{ fileName(pub.detail.softPath) }}</span>
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="发布时间">{{ pub.detail.releaseTime || '-' }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{ pub.detail.updateTime || '-' }}</el-descriptions-item>
                <el-descriptions-item label="审核状态">{{ auditText(pub.detail.auditStatus) }}</el-descriptions-item>
                <el-descriptions-item label="审核原因" v-if="pub.detail.auditDesc">{{ pub.detail.auditDesc
                    }}</el-descriptions-item>
                <el-descriptions-item label="转让状态">
                    <template
                        v-if="pub.detail.transferSaleStatus !== undefined && pub.detail.transferSaleStatus !== null && pub.detail.transferSaleStatus !== ''">
                        {{ pub.detail.transferSaleStatusIntro || transferSaleStatusText(pub.detail.transferSaleStatus)
                        }}
                    </template>
                    <template v-else>-</template>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer">
                <el-button @click="pub.detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 我发布的：有偿转让二次确认弹窗 -->
        <el-dialog title="有偿转让" :visible.sync="pub.transferVisible" width="460px" append-to-body
            @close="pubResetTransfer">
            <el-form label-width="90px" class="transfer-form">
                <el-form-item label="软件名称">
                    <span class="tf-text">{{ pub.transferRow && pub.transferRow.softwareName }}</span>
                </el-form-item>
                <el-form-item label="转让定价" required>
                    <el-input v-model="pub.transferCoin" size="small" placeholder="请输入转让定价（元）" style="width:200px" />
                    <span class="tf-unit">元（最小 0.01）</span>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="pub.transferVisible = false">取消</el-button>
                <el-button type="warning" :loading="pub.transferLoading" @click="pubConfirmTransfer">确认转让</el-button>
            </div>
        </el-dialog>

        <!-- 我参与的：申请验收弹窗 -->
        <el-dialog title="申请验收" :visible.sync="join.acceptDialogVisible" width="550px" append-to-body>
            <el-form :model="join.acceptForm" label-width="90px">
                <el-form-item label="需求标题">
                    <span>{{ join.acceptForm.title }}</span>
                </el-form-item>
                <el-form-item label="交付说明" required>
                    <el-input type="textarea" v-model="join.acceptForm.description" :rows="3"
                        placeholder="请简要描述交付内容"></el-input>
                </el-form-item>
                <el-form-item label="交付物上传">
                    <el-upload action="#" :auto-upload="false" :on-change="joinHandleFileChange"
                        :file-list="join.acceptForm.files" multiple :limit="3">
                        <el-button size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="upload-tip">最多3个文件，每个10M内，支持 zip/pdf/doc</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="join.acceptDialogVisible = false">取消</el-button>
                <el-button type="success" @click="joinSubmitAcceptConfirm"
                    :loading="join.acceptLoading">提交验收</el-button>
            </div>
        </el-dialog>

        <!-- 我参与的：需求详情弹窗 -->
        <el-dialog title="需求详情" :visible.sync="join.detailVisible" width="820px" append-to-body
            custom-class="myJoinDetailDialog">
            <div v-loading="join.detailLoading" class="detail-wrap">
                <template v-if="join.detailData">
                    <el-descriptions :column="2" border size="small" class="detail-block">
                        <el-descriptions-item label="需求编号">{{ join.detailData.demandNo || '-' }}</el-descriptions-item>
                        <el-descriptions-item label="需求标题">{{ join.detailData.title || '-' }}</el-descriptions-item>
                        <el-descriptions-item label="定制模式">{{ formatPayMode(join.detailData.mode)
                            }}</el-descriptions-item>
                        <el-descriptions-item label="当前状态">
                            <el-tag :type="joinStatusType(join.detailData.status)" size="small">{{
                                formatStatus(join.detailData.status) }}</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="预算金额">{{ join.detailData.budget != null ? join.detailData.budget +
                            ' 元' : '-' }}</el-descriptions-item>
                        <el-descriptions-item label="预算说明">{{ join.detailData.budgetRemark || '-'
                            }}</el-descriptions-item>
                        <el-descriptions-item label="需求详细说明" :span="2">{{ join.detailData.demand || '-'
                            }}</el-descriptions-item>
                        <el-descriptions-item label="中标团队">{{ join.detailData.selectedTeamName || '-'
                            }}</el-descriptions-item>
                        <el-descriptions-item label="托管金额">{{ join.detailData.escrowAmount != null ?
                            join.detailData.escrowAmount + ' 元' : '-' }}</el-descriptions-item>
                        <el-descriptions-item label="需求审核状态">
                            <el-tag
                                :type="join.detailData.demandAuditStatus == 1 ? 'success' : join.detailData.demandAuditStatus == 2 ? 'danger' : 'info'"
                                size="small">
                                {{ join.detailData.demandAuditStatus == 1 ? '已通过' : join.detailData.demandAuditStatus ==
                                    2 ? '已拒绝' : '待审核' }}
                            </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同审核状态">
                            <el-tag
                                :type="join.detailData.contractAuditStatus == 1 ? 'success' : join.detailData.contractAuditStatus == 2 ? 'danger' : 'info'"
                                size="small">
                                {{ join.detailData.contractAuditStatus == 1 ? '已通过' :
                                    join.detailData.contractAuditStatus == 2 ? '已拒绝' : '待审核' }}
                            </el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="创建时间">{{ join.detailData.createTime || '-'
                            }}</el-descriptions-item>
                        <el-descriptions-item label="更新时间">{{ join.detailData.updateTime || '-'
                            }}</el-descriptions-item>
                    </el-descriptions>

                    <div class="detail-subtitle">合同文件</div>
                    <div class="detail-file-card">
                        <template v-if="join.detailData.contractFileUrl">
                            <div class="file-main">
                                <i class="el-icon-document file-icon"></i>
                                <div class="file-info">
                                    <a class="detail-file-link" :href="fileUrl(join.detailData.contractFileUrl)"
                                        target="_blank" rel="noopener"
                                        :title="join.detailData.contractFileName || '合同文件'">
                                        {{ join.detailData.contractFileName || '合同文件' }}
                                    </a>
                                    <div class="file-meta">
                                        <span v-if="join.detailData.contractAuditStatus != null">
                                            审核状态：
                                            <el-tag
                                                :type="join.detailData.contractAuditStatus == 1 ? 'success' : join.detailData.contractAuditStatus == 2 ? 'danger' : 'info'"
                                                size="mini">
                                                {{ join.detailData.contractAuditStatus == 1 ? '已通过' :
                                                    join.detailData.contractAuditStatus == 2 ? '已拒绝' : '待审核' }}
                                            </el-tag>
                                        </span>
                                        <span v-if="join.detailData.contractAuditTime">审核时间：{{
                                            join.detailData.contractAuditTime }}</span>
                                    </div>
                                </div>
                                <a class="file-download-btn" :href="fileUrl(join.detailData.contractFileUrl)"
                                    target="_blank" rel="noopener">
                                    <i class="el-icon-download"></i> 下载
                                </a>
                            </div>
                            <div v-if="join.detailData.contractRemark" class="file-remark">
                                <span class="remark-label">备注：</span>
                                <span class="remark-text">{{ join.detailData.contractRemark }}</span>
                            </div>
                            <div v-if="join.detailData.contractAuditStatus == 2 && join.detailData.contractAuditRemark"
                                class="file-remark reject-reason">
                                <span class="remark-label">拒绝原因：</span>
                                <span class="remark-text">{{ join.detailData.contractAuditRemark }}</span>
                            </div>
                        </template>
                        <div v-else class="file-empty">
                            <i class="el-icon-document-delete"></i>
                            <span>暂未上传合同文件</span>
                        </div>
                    </div>

                    <div class="detail-subtitle">投标方案（{{ join.bidList.length }}）</div>
                    <el-table :data="join.bidList" size="small" border empty-text="暂无投标方案">
                        <el-table-column label="投标团队" width="120">
                            <template slot-scope="{ row }">{{ row.bid && row.bid.teamName || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="投标人" width="110">
                            <template slot-scope="{ row }">{{ row.bid && row.bid.userName || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="报价(元)" width="100">
                            <template slot-scope="{ row }">{{ row.bid && row.bid.price != null ? row.bid.price + ' 元' :
                                '-' }}</template>
                        </el-table-column>
                        <el-table-column label="工期(天)" width="90">
                            <template slot-scope="{ row }">{{ row.bid && row.bid.duration != null ? row.bid.duration + '
                                天' : ' - ' }}</template>
                        </el-table-column>
                        <el-table-column label="联系电话" width="130">
                            <template slot-scope="{ row }">{{ row.bid && row.bid.contactPhone || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="投标说明" min-width="160" show-overflow-tooltip>
                            <template slot-scope="{ row }">{{ row.bid && (row.bid.solution ||
                                row.bid.selfRecommendation) || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="投标状态" width="90">
                            <template slot-scope="{ row }">
                                <el-tag
                                    :type="row.bid && row.bid.status == 1 ? 'success' : row.bid && row.bid.status == 2 ? 'info' : 'warning'"
                                    size="small">
                                    {{ row.bid && row.bid.status == 1 ? '中标' : row.bid && row.bid.status == 2 ? '未中标' :
                                        '投标中' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否选中" width="80">
                            <template slot-scope="{ row }">
                                <el-tag :type="row.selected ? 'success' : 'info'" size="small">{{ row.selected ? '已选中' :
                                    '未选中' }}</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div slot="footer">
                <el-button size="small" @click="join.detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 发布缩水软件：发布表单弹窗 -->
        <el-dialog title="发布缩水软件" :visible.sync="pubForm.visible" width="760px" append-to-body @close="pubFormReset">
            <el-form :model="pubForm.form" :rules="pubForm.rules" ref="pubForm" label-width="170px" class="form-box">
                <el-form-item label="发布方式" prop="priceMode">
                    <el-radio-group v-model="pubForm.priceMode" @change="onPriceModeChange">
                        <el-radio-button label="free">免费发布</el-radio-button>
                        <el-radio-button label="paid">付费发布</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="软件名称" prop="softwareName">
                    <el-input v-model="pubForm.form.softwareName" maxlength="50" show-word-limit
                        placeholder="请输入软件名称" />
                </el-form-item>
                <el-form-item label="软件所属彩种" prop="preType">
                    <el-select v-model="pubForm.form.preType" placeholder="请选择彩种" filterable allow-create
                        style="width:100%">
                        <el-option v-for="t in lotteryOptions" :key="t.value" :label="t.label" :value="t.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="软件来源" prop="softwareSource">
                    <el-select v-model="pubForm.form.softwareSource" placeholder="请选择软件来源" filterable allow-create
                        style="width:100%">
                        <el-option v-for="s in sourceOptions" :key="s.value" :label="s.label" :value="s.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="软件基本情况介绍" prop="introduction">
                    <el-input v-model="pubForm.form.introduction" type="textarea" :rows="4" maxlength="500"
                        show-word-limit placeholder="请介绍软件功能、适用场景等基本情况" />
                </el-form-item>
                <el-form-item label="申请发布说明" prop="releaseNotes">
                    <el-input v-model="pubForm.form.releaseNotes" type="textarea" :rows="3" maxlength="300"
                        show-word-limit placeholder="请补充说明本次发布的背景或特别说明" />
                </el-form-item>
                <el-form-item label="函数公式" prop="formula">
                    <el-input v-model="pubForm.form.formula" type="textarea" :rows="2" placeholder="请填写软件涉及的函数公式" />
                </el-form-item>
                <el-form-item label="软件文件" prop="software">
                    <el-upload class="soft-upload" action="" :auto-upload="false" :show-file-list="true" :limit="1"
                        accept=".xls,.xlsx,.doc,.docx,.md,.markdown,.txt" :file-list="pubForm.fileList"
                        :on-change="pubChooseFile" :on-remove="pubOnFileRemove">
                        <el-button size="small" type="primary" :loading="pubForm.uploading">选择文件</el-button>
                        <div slot="tip" class="upload-tip">单个文件，支持 Excel / Word / Markdown / TXT 文档，大小请遵循平台限制</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="无病毒承诺" prop="noVirus">
                    <el-radio-group v-model="pubForm.form.noVirus">
                        <el-radio :label="1">是，承诺无病毒</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否自动更新开奖" prop="updateLottery">
                    <el-radio-group v-model="pubForm.form.updateLottery">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="价格(元)" prop="coin" v-if="pubForm.priceMode === 'paid'">
                    <el-input-number v-model="pubForm.form.coin" :controls="false" style="width: 200px" />
                    <div class="price-tip">此处填写软件的收费价格，单位为元，请按实际定价填写。</div>
                </el-form-item>
                <el-form-item label="搜索关键字" prop="keyword">
                    <el-input v-model="pubForm.form.keyword" maxlength="100" placeholder="便于买家搜索，多个用空格分隔（可选）" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="pubForm.visible = false">取消</el-button>
                <el-button type="primary" @click="pubSubmit" :loading="pubForm.saveLoading">提交发布</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    softwareReleaseSummaryList,
    softwareSourceList,
    softwareFreeRelease,
    softwarePaidRelease,
    softwarePaidTransfer
} from '@/api/software'
import { queryLotteryType, queryUuIdInfo } from '@/api/common'

export default {
    data() {
        return {
            activeTab: 'published',
            // 彩种 / 来源字典
            lotteryTypeMap: {},
            lotteryColorMap: {},
            lotteryOptions: [],
            sourceOptions: [],
            sourceColorMap: {},

            // ===== Tab1 我发布的 =====
            pub: {
                loading: false,
                list: [],
                total: 0,
                query: {
                    pageNum: 1,
                    pageSize: 10,
                    keyword: '',
                    preType: '',
                    softwareSource: '',
                    isFree: '',
                    auditStatus: '',
                    startDate: '',
                    endDate: '',
                },
                dateRange: [],
                detailVisible: false,
                detail: null,
                transferVisible: false,
                transferRow: null,
                transferCoin: '0.01',
                transferLoading: false,
            },

            // ===== Tab3 发布表单 =====
            pubForm: {
                visible: false,
                priceMode: 'free',
                form: {
                    id: null,
                    softwareName: '',
                    preType: '',
                    softwareSource: '',
                    introduction: '',
                    releaseNotes: '',
                    formula: '',
                    software: '',
                    noVirus: 1,
                    updateLottery: 1,
                    isFree: 1,
                    coin: 1,
                    startDate: '',
                    endDate: '',
                    keyword: '',
                    dateRange: [],
                },
                rules: {
                    softwareName: { required: true, message: '请输入名称', trigger: 'change' },
                    preType: { required: true, message: '请选择软件所属彩种', trigger: 'change' },
                    softwareSource: { required: true, message: '请输入软件来源', trigger: 'change' },
                    introduction: { required: true, message: '请填写描述', trigger: 'change' },
                    releaseNotes: { required: true, message: '请填写说明', trigger: 'change' },
                    formula: { required: true, message: '请填写函数公式', trigger: 'change' },
                    software: { required: true, message: '请上传软件文件', trigger: 'change' },
                    noVirus: { required: true, message: '请选择无病毒承诺', trigger: 'change' },
                    updateLottery: { required: true, message: '请选择是否自动更新开奖', trigger: 'change' },
                },
                fileList: [],
                uploading: false,
                saveLoading: false,
            },

            // ===== Tab2 我参与的 =====
            join: {
                loading: false,
                list: [],
                acceptDialogVisible: false,
                acceptLoading: false,
                acceptForm: { id: null, customId: null, title: '', description: '', files: [] },
                detailVisible: false,
                detailLoading: false,
                detailData: null,
                bidList: [],
            },

            // 我参与的：状态/付费模式映射
            statusMap: {
                1: '已发布待选标',
                2: '已选标待签合同',
                3: '已签合同待托管项目款',
                4: '已托管项目款工作中',
                5: '已验收',
                6: '交易完成',
                7: '已暂停',
                8: '已关闭',
                9: '退款中',
                10: '已退款',
                11: '待审核',
                12: '已审核待签约'
            },
            payModeMap: {
                personal: '个人',
                crowdfunding: '多人众筹',
                free: '免费',
                paid_escrow: '付费担保'
            },
        }
    },
    created() {
        this.getLotteryTypeDict()
        this.loadSourceOptions()
        this.pubGetList()
    },
    methods: {
        // ============ 公共：彩种/来源字典 ============
        async getLotteryTypeDict() {
            try {
                const res = await queryLotteryType()
                let list = []
                if (Array.isArray(res)) list = res
                else if (res && Array.isArray(res.data)) list = res.data
                else if (res && res.data && Array.isArray(res.data.data)) list = res.data.data
                else if (res && Array.isArray(res.rows)) list = res.rows
                const palette = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#9254DE', '#13C2C2', '#EB2F96', '#FA8C16', '#2F54EB']
                const nameMap = {}, colorMap = {}, opts = []
                    ; (list || []).forEach((item, i) => {
                        const val = item.dictValue
                        if (val === undefined || val === null) return
                        nameMap[val] = item.dictLabel
                        colorMap[val] = palette[i % palette.length]
                        opts.push({ label: item.dictLabel !== undefined ? item.dictLabel : val, value: val })
                    })
                this.lotteryTypeMap = nameMap
                this.lotteryColorMap = colorMap
                this.lotteryOptions = opts
            } catch (e) { /* 字典拉取失败不影响列表展示 */ }
        },
        getLotteryName(preType) {
            if (preType === undefined || preType === null || preType === '') return '-'
            return this.lotteryTypeMap[preType] || preType
        },
        getLotteryColor(preType) {
            return this.lotteryColorMap[preType] || '#909399'
        },
        loadSourceOptions() {
            softwareSourceList().then(res => {
                const base = res && res.data !== undefined ? res.data : res
                const list = Array.isArray(base) ? base : (base && base.rows) || []
                if (list.length) {
                    this.sourceOptions = list.map(item => {
                        if (typeof item === 'string') return { label: item, value: item }
                        const label = item.dictLabel !== undefined ? item.dictLabel
                            : (item.label !== undefined ? item.label : item.value)
                        const value = item.dictValue !== undefined ? item.dictValue
                            : (item.value !== undefined ? item.value : label)
                        return { label, value }
                    })
                }
            }).catch(() => { })
        },
        buildSourceColorMap(rows) {
            const palette = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#9254DE', '#13C2C2', '#EB2F96', '#FA8C16', '#2F54EB']
            const map = Object.assign({}, this.sourceColorMap)
            let idx = Object.keys(map).length
                ; (rows || []).forEach(r => {
                    const v = r.softwareSourceIntro
                    if (v === undefined || v === null || v === '') return
                    if (!(v in map)) { map[v] = palette[idx % palette.length]; idx++ }
                })
            this.sourceColorMap = map
        },
        getSourceColor(name) {
            if (name === undefined || name === null || name === '') return '#909399'
            return this.sourceColorMap[name] || '#909399'
        },
        // ============ 公共：文件/下载 ============
        fileName(p) {
            if (!p) return ''
            const clean = String(p).split('?')[0]
            return clean.substring(clean.lastIndexOf('/') + 1)
        },
        downloadFile(path) {
            if (!path) return
            const url = path.startsWith('/') ? '/stage-api' + path : '/stage-api/' + path
            this.$http.get(url, { responseType: 'blob' }).then(blob => {
                if (!(blob instanceof Blob) || (blob.type && blob.type.indexOf('json') > -1)) {
                    this.$message && this.$message.error((blob && blob.msg) || '下载失败，请确认已登录')
                    return
                }
                this.$utils.downloadFile(blob, this.fileName(path), blob.type || 'application/octet-stream')
            }).catch(e => {
                this.$message && this.$message.error('下载失败：' + ((e && e.msg) || '网络异常'))
            })
        },
        fileUrl(f) {
            if (f == null) return ''
            let url = typeof f === 'string' ? f : (f.url || f.fileUrl || f.path || '')
            if (!url) return ''
            if (/^https?:\/\//i.test(url)) return url
            const base = process.env.VUE_APP_BASE_API || ''
            return base + (url.charAt(0) === '/' ? '' : '/') + url
        },
        // ============ 公共：审核状态映射 ============
        auditText(status) {
            const map = { 0: '待审核', 1: '已通过', 2: '已拒绝' }
            return map[status] !== undefined ? map[status] : (status === '' || status === null || status === undefined ? '待审核' : '状态' + status)
        },
        auditType(status) {
            const map = { 0: 'warning', 1: 'success', 2: 'danger' }
            return map[status] || 'info'
        },
        isFree(row) {
            if (row && row.isFree !== undefined && row.isFree !== null) return Number(row.isFree) === 1
            return row && (row.coin === undefined || row.coin === null || Number(row.coin) === 0)
        },
        transferSaleStatusText(status) {
            const map = { 0: '不可转让', 1: '可申请转让', 2: '已发起转让（在售）', 3: '已转让（我卖出的）', 4: '受让获得（我买到的）' }
            return map[status] !== undefined ? map[status] : ('状态' + status)
        },
        onTabChange() {
            if (this.activeTab === 'published') this.pubGetList()
            else if (this.activeTab === 'joined') this.joinGetList()
        },

        // ============ Tab1 我发布的：列表 ============
        async pubGetList() {
            this.pub.loading = true
            try {
                const q = this.pub.query
                const params = { pageNum: q.pageNum, pageSize: q.pageSize }
                if (q.keyword) params.keyword = q.keyword
                if (q.preType) params.preType = q.preType
                if (q.softwareSource) params.softwareSource = q.softwareSource
                if (q.isFree !== '' && q.isFree !== null && q.isFree !== undefined) params.isFree = q.isFree
                if (q.auditStatus !== '' && q.auditStatus !== null && q.auditStatus !== undefined) params.auditStatus = q.auditStatus
                if (q.startDate) params.startDate = q.startDate
                if (q.endDate) params.endDate = q.endDate
                const res = await softwareReleaseSummaryList(params)
                const base = res && res.data !== undefined ? res.data : res
                const rows = base.rows || base.list || (Array.isArray(base) ? base : [])
                this.pub.list = Array.isArray(rows) ? rows : []
                this.buildSourceColorMap(this.pub.list)
                this.pub.total = base.total || (base.data && base.data.total) || this.pub.list.length
            } catch (e) {
                this.pub.list = []
                this.pub.total = 0
            } finally {
                this.pub.loading = false
            }
        },
        pubSearch() {
            this.pub.query.pageNum = 1
            this.pubGetList()
        },
        onPubDateChange(val) {
            if (val && val.length === 2) {
                this.pub.query.startDate = val[0]
                this.pub.query.endDate = val[1]
            } else {
                this.pub.query.startDate = ''
                this.pub.query.endDate = ''
            }
            this.pubSearch()
        },
        pubHandlePage(page) {
            this.pub.query.pageNum = page
            this.pubGetList()
        },
        pubViewDetail(row) {
            this.pub.detail = row
            this.pub.detailVisible = true
        },
        pubOpenTransfer(row) {
            this.pub.transferRow = row
            const origin = row && row.coin
            const n = Number(origin)
            this.pub.transferCoin = (origin !== undefined && origin !== null && origin !== '' && !isNaN(n) && n > 0) ? String(n) : '0.01'
            this.pub.transferVisible = true
        },
        pubResetTransfer() {
            this.pub.transferRow = null
            this.pub.transferCoin = '0.01'
            this.pub.transferLoading = false
        },
        pubConfirmTransfer() {
            if (!this.pub.transferRow) return
            const coin = Number(this.pub.transferCoin)
            if (isNaN(coin) || coin <= 0) {
                this.$message.warning('请输入有效的转让定价（数字，需大于 0）')
                return
            }
            const id = this.pub.transferRow.id
            if (id === undefined || id === null || id === '') {
                this.$message.warning('未获取到软件ID，无法发起转让')
                return
            }
            this.pub.transferLoading = true
            softwarePaidTransfer({ id: Number(id), coin })
                .then(res => {
                    if (res && res.code === 200) {
                        this.$set(this.pub.transferRow, 'transferSaleStatus', 2)
                        this.pub.transferVisible = false
                        this.$message.success('有偿转让申请已提交，等待审核')
                        this.pubGetList()
                    } else {
                        this.$message.error((res && res.msg) || '提交失败')
                    }
                })
                .catch(err => {
                    this.$message.error((err && err.msg) ? err.msg : '提交失败，请稍后重试')
                })
                .finally(() => {
                    this.pub.transferLoading = false
                })
        },

        // ============ Tab3 发布缩水软件：弹窗表单 ============
        openPublishDialog() {
            this.pubForm.visible = true
        },
        onPriceModeChange() {
            this.pubForm.form.isFree = this.pubForm.priceMode === 'free' ? 1 : 0
            this.$nextTick(() => {
                if (this.$refs.pubForm) this.$refs.pubForm.clearValidate()
            })
        },
        pubChooseFile(file, fileList) {
            this.pubForm.fileList = fileList
            const raw = file.raw
            if (!raw) return
            const name = raw.name || ''
            const ext = name.slice(name.lastIndexOf('.')).toLowerCase()
            const allowedExts = ['.xls', '.xlsx', '.doc', '.docx', '.md', '.markdown', '.txt']
            if (!allowedExts.includes(ext)) {
                this.$message.error('仅支持上传 Excel、Word、Markdown、TXT 文件')
                this.pubForm.fileList = []
                return
            }
            const bizId = this.pubForm.form.id
            const params = `?fileType=software&bizId=${bizId}&number=software`
            const fd = new FormData()
            fd.append('file', raw)
            this.pubForm.uploading = true
            this.$utils.upLoadFile(params, fd).then(res => {
                if (!res || !res.data || !res.data.urls) {
                    const msg = (res && res.header && res.header.msg) ? res.header.msg : '上传失败，请稍后重试'
                    throw { msg }
                }
                this.pubForm.form.software = res.data.urls
                this.$refs.pubForm.validateField('software')
                this.$message.success('软件文件上传成功')
            }).catch(err => {
                this.$message.error((err && err.msg) ? err.msg : '上传失败，请确认已登录后重试')
                this.pubForm.fileList = []
            }).finally(() => {
                this.pubForm.uploading = false
            })
        },
        pubOnFileRemove() {
            this.pubForm.form.software = ''
            this.pubForm.fileList = []
        },
        pubSubmit() {
            this.$refs.pubForm.validate((valid) => {
                if (!valid) {
                    this.$message.warning('请完善标红的必填项后再提交')
                    return false
                }
                if (this.pubForm.priceMode === 'paid') {
                    if (this.pubForm.form.coin === '' || this.pubForm.form.coin === null || this.pubForm.form.coin === undefined) {
                        this.$message.warning('请填写收费价格')
                        return false
                    }
                }
                const f = this.pubForm.form
                const payload = {
                    id: f.id === null || f.id === '' ? null : Number(f.id),
                    softwareName: f.softwareName,
                    preType: f.preType,
                    introduction: f.introduction,
                    releaseNotes: f.releaseNotes,
                    formula: f.formula,
                    isFree: f.isFree,
                    auditStatus: 0,
                    startDate: f.dateRange && f.dateRange[0] ? f.dateRange[0] : '',
                    endDate: f.dateRange && f.dateRange[1] ? f.dateRange[1] : '',
                    keyword: f.keyword,
                    softwareSource: f.softwareSource,
                    software: f.software,
                    noVirus: f.noVirus,
                    updateLottery: f.updateLottery,
                }
                if (this.pubForm.priceMode === 'paid') payload.coin = f.coin
                this.pubForm.saveLoading = true
                const api = this.pubForm.priceMode === 'paid' ? softwarePaidRelease : softwareFreeRelease
                const successMsg = this.pubForm.priceMode === 'free' ? '免费发布成功，等待审核' : '付费发布成功，等待审核'
                api(payload).then(res => {
                    if (res.code === 200) {
                        this.$message.success(successMsg)
                        this.pubForm.visible = false
                        this.pubGetList()
                    } else {
                        this.$message.error(res.msg || '发布失败')
                    }
                }).catch(err => {
                    this.$message.error((err && err.msg) ? err.msg : '发布失败，请稍后重试')
                }).finally(() => {
                    this.pubForm.saveLoading = false
                })
            })
        },
        pubFormReset() {
            if (this.$refs.pubForm) this.$refs.pubForm.resetFields()
            this.pubForm.fileList = []
            this.pubForm.form.software = ''
            this.pubForm.priceMode = 'free'
            this.pubForm.form.isFree = 1
            this.pubForm.form.noVirus = 1
            this.pubForm.form.updateLottery = 1
            queryUuIdInfo().then(res => { this.pubForm.form.id = res })
        },

        // ============ Tab2 我参与的：列表 ============
        joinD(row) { return row && row.demand || {} },
        joinB(row) { return row && row.bid || {} },
        async joinGetList() {
            this.join.loading = true
            try {
                const res = await this.$http.get('/stage-api/software/custom/demand/my/participated/list', {
                    params: { pageNum: 1, pageSize: 10 }
                })
                const base = res && res.data !== undefined ? res.data : res
                const rows = base.rows || base.list || (Array.isArray(base) ? base : [])
                this.join.list = Array.isArray(rows) ? rows : []
            } catch (e) {
                this.join.list = []
            } finally {
                this.join.loading = false
            }
        },
        formatStatus(status) {
            if (status === undefined || status === null || status === '') return '-'
            return this.statusMap[status] || String(status)
        },
        formatPayMode(mode) {
            return this.payModeMap[mode] || mode || '-'
        },
        joinStatusType(status) {
            const text = this.formatStatus(status)
            const map = {
                '已发布待选标': '',
                '已选标待签合同': 'warning',
                '已签合同待托管项目款': '',
                '已托管项目款工作中': '',
                '已验收': 'danger',
                '交易完成': 'success',
                '已暂停': 'warning',
                '已关闭': 'info',
                '退款中': 'warning',
                '已退款': 'info',
                '待审核': 'info',
                '已审核待签约': 'warning',
            }
            return map[text] || ''
        },
        joinUploadContract() {
            this.$prompt('请上传合同扫描件（非必填，但强烈建议）', '上传合同', {
                inputPlaceholder: '选择文件后点击确认上传',
            }).then(() => {
                this.$message.info('合同上传功能开发中')
            }).catch(() => { })
        },
        joinSignContract(row) {
            const demandId = this.joinD(row).id
            const demandNo = this.joinD(row).demandNo || demandId
            this.$confirm(`确认签约需求「${this.joinD(row).title || demandNo}」？签约后请尽快完成合同相关流程。`, '团队签约确认', {
                confirmButtonText: '确认签约',
                cancelButtonText: '取消',
                type: 'primary'
            }).then(async () => {
                try {
                    await this.$http.post('/stage-api/software/custom/contract/sign', { id: demandId, remark: '' })
                    this.$message.success('签约成功')
                    this.joinGetList()
                } catch (e) {
                    this.$message.error('签约失败，请稍后重试')
                }
            }).catch(() => { })
        },
        joinRejectContract(row) {
            const demandId = this.joinD(row).id
            this.$prompt('请输入拒签原因（可选）', '拒签确认', {
                inputType: 'textarea',
                inputPlaceholder: '如无故拒签，请谨慎操作',
                confirmButtonText: '确认拒签',
                cancelButtonText: '取消',
            }).then(async ({ value }) => {
                try {
                    await this.$http.post('/stage-api/software/custom/contract/reject', { id: demandId, remark: value || '' })
                    this.$message.success('已拒签')
                    this.joinGetList()
                } catch (e) {
                    this.$message.error('拒签失败，请稍后重试')
                }
            }).catch(() => { })
        },
        joinSubmitAccept(row) {
            this.join.acceptForm = {
                id: null,
                customId: this.joinD(row).id,
                title: this.joinD(row).title,
                description: '',
                files: [],
            }
            this.join.acceptDialogVisible = true
        },
        joinHandleFileChange(file, fileList) {
            this.join.acceptForm.files = fileList
        },
        async joinSubmitAcceptConfirm() {
            if (!this.join.acceptForm.description.trim()) {
                this.$message.warning('请填写交付说明')
                return
            }
            if (this.join.acceptForm.files.length === 0) {
                this.$message.warning('请至少上传一个验收材料')
                return
            }
            const customId = this.join.acceptForm.customId
            if (customId === undefined || customId === null || customId === '') {
                this.$message.warning('未获取到定制需求ID')
                return
            }
            this.join.acceptLoading = true
            try {
                const filePaths = []
                for (const f of this.join.acceptForm.files) {
                    const raw = f.raw
                    if (!raw) continue
                    const fd = new FormData()
                    fd.append('file', raw)
                    const params = `?fileType=acceptance&bizId=${customId}&number=acceptance`
                    const upRes = await this.$utils.upLoadFile(params, fd)
                    const path = upRes && upRes.data && upRes.data.urls
                    if (!path) throw { msg: '验收材料上传失败，请重试' }
                    filePaths.push(path)
                }
                const payload = {
                    customId: Number(customId),
                    acceptanceRemark: this.join.acceptForm.description,
                    acceptanceFile: filePaths.join(','),
                }
                await this.$http.post('/stage-api/software/custom/delivery/submit', payload)
                this.$message.success('验收申请已提交，等待发布者确认')
                this.join.acceptDialogVisible = false
                this.joinGetList()
            } catch (e) {
                const msg = (e && e.msg) ? e.msg : '提交失败，请稍后重试'
                this.$message.error(msg)
            } finally {
                this.join.acceptLoading = false
            }
        },
        joinWithdraw(row) {
            const price = this.joinB(row).price || this.joinB(row).amount || this.joinB(row).bidAmount || 0
            this.$confirm(`确认提现 ¥${price}？`, '申请提现', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'info'
            }).then(async () => {
                try {
                    await this.$http.post('/softwareCustom/withdraw', { id: this.joinD(row).id })
                    this.$message.success('提现申请已提交')
                    this.joinGetList()
                } catch (e) { /* 提现失败仅静默处理 */ }
            }).catch(() => { })
        },
        async joinViewDetail(row) {
            const id = this.joinD(row).id
            if (id === undefined || id === null || id === '') {
                this.$message.error('当前行缺少需求ID，无法查看详情')
                return
            }
            this.join.detailVisible = true
            this.join.detailLoading = true
            this.join.detailData = null
            this.join.bidList = []
            try {
                const res = await this.$http.get('/stage-api/software/custom/demand/' + id)
                const base = res && res.data !== undefined ? res.data : res
                const demand = base.demand || (base.id !== undefined ? base : null)
                if (!demand) {
                    this.$message.error('详情数据为空')
                    return
                }
                this.join.detailData = demand
                this.join.bidList = Array.isArray(base.bids) ? base.bids : []
            } catch (e) {
                this.$message.error('获取详情失败')
            } finally {
                this.join.detailLoading = false
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.shrink-software {
    .top-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .top-title {
            font-size: 18px;
            font-weight: bold;
            color: #333;
        }
    }

    .page-block {
        padding: 4px 2px;
    }

    .header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 16px;
        flex-wrap: wrap;

        .refresh-btn {
            cursor: pointer;
            color: #2899df;
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }

        .tip-text {
            color: #909399;
            font-size: 13px;
        }
    }

    .publish-tip {
        background: #f4f8ff;
        border: 1px solid #e3edfb;
        border-radius: 6px;
        padding: 12px 16px;
        color: #606266;
        font-size: 13px;
        line-height: 1.6;

        i {
            color: #409eff;
            margin-right: 4px;
        }
    }

    .pager {
        margin-top: 16px;
        text-align: right;
    }

    .lottery-tag-custom {
        border-color: transparent;
    }

    .op-btns {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        justify-content: flex-start;

        .tf-status-text {
            color: #909399;
            font-size: 12px;
            line-height: 28px;
        }
    }

    .file-link {
        color: #2899df;
        cursor: pointer;
        word-break: break-all;

        &:hover {
            text-decoration: underline;
        }
    }

    .transfer-form {
        .tf-text {
            color: #303133;
            font-weight: 500;
        }

        .tf-unit {
            margin-left: 8px;
            color: #909399;
            font-size: 12px;
        }
    }

    .form-box {
        max-width: 960px;
    }

    .price-tip {
        margin-top: 6px;
        color: #f56c6c;
        font-size: 12px;
        line-height: 1.4;
    }

    .upload-tip {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
    }
}
</style>

<!-- 非 scoped：详情弹窗 append-to-body 后 scoped 样式无法生效，需全局样式 -->
<style lang="scss">
.myJoinDetailDialog {
    .detail-wrap {
        min-height: 200px;
    }

    .detail-block {
        margin-bottom: 16px;
    }

    .detail-subtitle {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin: 16px 0 10px;
        padding-left: 8px;
        border-left: 3px solid #2899df;
    }

    .detail-file-card {
        background: #f8fafc;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        padding: 14px 16px;
        margin-bottom: 8px;

        .file-main {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .file-icon {
            font-size: 36px;
            color: #909399;
            flex-shrink: 0;
        }

        .file-info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

        .detail-file-link {
            color: #409eff;
            font-size: 14px;
            font-weight: 500;
            text-decoration: none;
            cursor: pointer;
            word-break: break-all;

            &:hover {
                text-decoration: underline;
            }
        }

        .file-meta {
            font-size: 12px;
            color: #909399;
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            align-items: center;
        }

        .file-download-btn {
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 6px 14px;
            background: #409eff;
            color: #fff;
            font-size: 13px;
            border-radius: 4px;
            text-decoration: none;
            cursor: pointer;
            transition: background 0.15s;

            &:hover {
                background: #66b1ff;
            }
        }

        .file-remark {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px dashed #e4e7ed;
            font-size: 13px;
            line-height: 1.6;
            color: #606266;

            .remark-label {
                color: #909399;
                margin-right: 4px;
            }

            .remark-text {
                color: #303133;
            }
        }

        .reject-reason {
            .remark-label {
                color: #f56c6c;
            }

            .remark-text {
                color: #f56c6c;
            }
        }

        .file-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 24px 0;
            color: #c0c4cc;
            font-size: 13px;

            i {
                font-size: 36px;
            }
        }
    }
}
</style>
